import {createSelector} from "reselect";
import {IStore} from "modules/types/store";
import {getUser} from "modules/selectors/user";
import {RequestState} from "modules/enums";

export const getSbkEligibilityState = ({sbkEligibility}: IStore) => sbkEligibility;

export const getSbkEligibilityFromApi = createSelector(
	getSbkEligibilityState,
	(state) => state.eligibility
);

export const getIsSbkEligibilityLoading = createSelector(
	getSbkEligibilityState,
	(state) => state.requestState === RequestState.Requested
);

export const getIsSbkEligibilityChecked = createSelector(
	getSbkEligibilityState,
	(state) => state.requestState === RequestState.Received
);

export const getIsSbkEligibleCombined = createSelector(
	getUser,
	getSbkEligibilityFromApi,
	(user, apiEligibility) => {
		if (user) {
			return user.sbkEligible === true;
		}
		return apiEligibility?.eligible === true;
	}
);
